module.exports = __webpack_public_path__ + "img/jordan-2.84bd29b2.png";